import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

import theme from '~/theme';

import Image from '~/components/base/Image';
import BaseLink from '~/components/base/BaseLink';

import { transition } from '~/styles/transition';
import { hexToRgba, formatText } from '~/utilities/helpers';

const AppImage = styled(Image)`
    max-width: 134px;
    margin-top: 20px;
    ${transition({}, 'box-shadow', 'outline')};
`;

const AppLink = styled(BaseLink)`
    &:hover,
    &:focus {
        ${AppImage} {
            box-shadow: 0 2px 20px 0
                ${({ theme }) => hexToRgba(theme.colors.primary.black, 0.75)};
            outline: 2px solid ${theme.colors.text.lightBlue};
        }
    }
`;

const NavCol = styled.li`
    flex: 1 1 calc(50% - 15px);

    @media (min-width: ${({ theme }) => theme.breakpoint.desktop}) {
        flex: 1 1 calc(25% - 15px);
    }
`;

export const NavHeaderFont = css`
    font-size: 1.7rem;
    color: ${theme.colors.primary.yellow};
    font-weight: ${theme.fontWeights.black};
    margin-bottom: 10px;
    line-height: 1.2;
`;

const NavLinkHeader = styled(BaseLink)`
    display: block;
    ${transition({}, 'text-decoration')};
    ${NavHeaderFont};

    &:hover,
    &:focus {
        text-decoration: underline;
    }
`;

const NavHeader = styled.span`
    display: block;
    ${NavHeaderFont};
`;

const NavLink = styled(NavLinkHeader)`
    color: ${({ theme }) => theme.colors.primary.white};
    font-weight: ${({ theme }) => theme.fontWeights.medium};
`;

const NavItems = ({ menuItems, appLinks }) =>
    menuItems.nodes.map(({ id, url, label, childItems }, index) => {
        const HeaderItem = url === '#' ? NavHeader : NavLinkHeader;
        return (
            <NavCol key={id}>
                <HeaderItem to={url}>{label}</HeaderItem>
                {childItems?.nodes?.length ? (
                    <ul>
                        {childItems.nodes.map(({ id, url, label }) => (
                            <li key={id}>
                                <NavLink to={url}>{formatText(label)}</NavLink>
                            </li>
                        ))}
                        {appLinks?.length &&
                        index === menuItems.nodes.length - 1
                            ? appLinks.map(({ linkUrl, badge }) => (
                                  <li key={linkUrl}>
                                      <AppLink to={linkUrl}>
                                          <AppImage {...badge} />
                                      </AppLink>
                                  </li>
                              ))
                            : null}
                    </ul>
                ) : null}
            </NavCol>
        );
    });

NavItems.propTypes = {
    menuItems: PropTypes.shape({}).isRequired,
    appLinks: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default NavItems;
